<template>
  <div>
    <fidelior-title text="Register" />
    <b-form @submit="register">
      <div class="container-fluid">
        <div class="row">
          <div class="col-sm-6">
            <b-form-group
              id="input-group-first-name"
              label="First name"
              label-for="input-first-name"
            >
              <b-form-input id="input-first-name" v-model="form.firstName"></b-form-input>
            </b-form-group>
          </div>
          <div class="col-sm-6">
            <b-form-group id="input-group-last-name" label="Last name" label-for="input-last-name">
              <b-form-input id="input-last-name" v-model="form.lastName"></b-form-input>
            </b-form-group>
          </div>
        </div>
        <div class="row">
          <div class="col-sm-6">
            <b-form-group id="input-group-email" label="E-mail" label-for="input-email">
              <b-form-input
                id="input-email"
                v-model="form.email"
                type="email"
                required
                placeholder="E-mail address"
                class="mb-2"
              ></b-form-input>
            </b-form-group>
          </div>
          <div class="col-sm-6">
            <b-form-group id="input-group-password" label="Password" label-for="input-password">
              <b-form-input
                id="input-password"
                label="Password"
                v-model="form.password"
                required
                placeholder="Password"
                class="mb-2"
                type="password"
              ></b-form-input>
            </b-form-group>
          </div>
        </div>
        <div class="row">
          <div class="col-sm-6">
            <fidelior-role v-model="form.primaryRole" />
          </div>
          <div class="col-sm-6">
              <fidelior-areas v-model="form.areas" />
          </div>
        </div>
        <div class="row mt-2">
          <div class="col">
            <b-button variant="danger" @click="back">Back</b-button>
          </div>
          <div class="col">
            <b-button class="float-right" variant="danger" type="submit" :disabled="working">
              <font-awesome-icon icon="circle-notch" class="fa-spin mr-2" v-if="working" />Register
            </b-button>
          </div>
        </div>
      </div>
    </b-form>
  </div>
</template>

<script>
import router from "../router";

export default {
  data() {
    return {
      form: {
        email: "",
        password: "",
        firstName: "",
        lastName: "",
        primaryRole: "",
        areas: []
      }
    };
  },
  computed: {
    working() {
      return this.$store.state.working;
    }
  },
  methods: {
    register(evt) {
      evt.preventDefault();
    },
    back() {
      router.replace("/login");
    }
  }
};
</script>